import { Component, OnInit } from '@angular/core';
import { ExtractsService } from '../../services/extracts-service/extracts.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import {TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';

// PrimeNG Modules
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';
import { ListboxModule } from 'primeng/listbox';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';
import {DropdownModule} from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-extract-prod',
  standalone: true,
  templateUrl: './extract-prod.component.html',
  imports: [
    CommonModule,
    FormsModule,
    BreadcrumbModule,
    CardModule,
    ButtonModule,
    TagModule,
    DividerModule,
    TooltipModule,
    ListboxModule,
    InputTextModule,
    OverlayPanelModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    TableModule,
    DropdownModule,
    DialogModule,
    ToastModule,DatePickerModule
  ],
  styleUrls: ['./extract-prod.component.scss'],
  providers: [DatePipe,MessageService]
})
export class ExtractProdComponent implements OnInit {

  // Breadcrumb Config
  breadcrumbHome = {icon: 'pi pi-database', to: 'extract-prod'};
  breadcrumbItems = [{label: 'Rapports Productions'}];

  // Data Lists & Filters
  rapportItems: any[] = [];
  selectedRapport: string | null = null;

  protected readonly INTERACTION_DOSSIER_REPORTS = [
    'ISUPPLEANCE_EXTRACTS_RAPPORT_PROD_PAR_INTERACTION',
    'ISUPPLEANCE_EXTRACTS_RAPPORT_PROD_PAR_DOSSIER'
  ];

  protected readonly AGENT_REPORTS = [
    'ISUPPLEANCE_EXTRACTS_RAPPORT_PROD_AGENT',
    'ISUPPLEANCE_EXTRACTS_RAPPORT_PROD_AGENT_HEURE',
    'ISUPPLEANCE_EXTRACTS_RAPPORT_PROD_AGENT_MENSUEL',
    'ISUPPLEANCE_EXTRACTS_RAPPORT_STAT_AGENT_DETAILS'
  ];

  // DO
  doList: string[] = [];
  filteredDoList: string[] = [];
  doSearchText: string = '';
  selectedDo: string = 'all';

  // Agents
  agentList: string[] = [];
  filteredAgentList: string[] = [];
  agentSearchText: string = '';
  selectedAgent: string = 'all';

  // Queues
  queueList: string[] = [];
  filteredQueueList: string[] = [];
  queueSearchText: string = '';
  selectedQueue: string = 'all';

  // Dates
  startDate: Date | undefined;
  endDate: Date | undefined;
  minDate: Date;
  maxDate: Date;
  today: Date;

  // Loading states
  loading = false;
  loadingAgents = false;
  loadingQueues = false;
  loadingDo = false;
  showFilters = false;

  exporting: boolean = false;
  progressValue: number = 0;
  progressInterval: any;

  previewVisible: boolean = false;
  previewData: any[] = [];
  previewColumns: any[] = [];
  loadingPreview: boolean = false;

  constructor(
    private extractsService: ExtractsService,
    private datePipe: DatePipe,
    private messageService: MessageService
  ) {
    this.today = new Date();
    this.today.setHours(0, 0, 0, 0);
    this.minDate = new Date(2024, 0, 1);
    this.maxDate = new Date(this.today);
    this.maxDate.setDate(this.today.getDate() - 1);
  }

  ngOnInit() {
    this.loadListRapports();
    this.initFilteredLists();
  }

  initFilteredLists() {
    this.filteredDoList = ['all'];
    this.filteredAgentList = ['all'];
    this.filteredQueueList = ['all'];
  }

  validateDates(): boolean {
    if (!this.startDate || !this.endDate) {
      return false;
    }
    const start = new Date(this.startDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(this.endDate);
    end.setHours(0, 0, 0, 0);
    return end >= start && end <= this.maxDate;
  }

  loadListRapports() {
    this.loading = true;
    this.extractsService.list_views().subscribe({
      next: (data: any) => {
        this.rapportItems = this.generateRapportItems(data);
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Erreur lors du chargement des rapports', err);
        this.rapportItems = [];
        this.loading = false;
      }
    });
  }

private async loadDoList(): Promise<void> {
  this.loadingDo = true;
  try {
    const doData = await this.extractsService.list_do().toPromise() as string[];
    // <-- Ajout du type
    this.doList = ['all', ...(doData || [])];
    this.filteredDoList = [...this.doList];
  } catch (error) {
    console.error('Erreur lors du chargement des DO', error);
    this.doList = ['all'];
    this.filteredDoList = ['all'];
  } finally {
    this.loadingDo = false;
  }
}

  loadAgents() {
    this.loadingAgents = true;
    this.extractsService.list_agents().subscribe({
      next: (agents) => {
        this.agentList = ['all', ...(agents || [])];
        this.filteredAgentList = [...this.agentList];
        this.loadingAgents = false;
      },
      error: (err) => {
        console.error('Erreur lors du chargement des agents', err);
        this.agentList = ['all'];
        this.filteredAgentList = ['all'];
        this.loadingAgents = false;
      }
    });
  }

  private async loadQueueList(): Promise<void> {
    this.loadingQueues = true;
    try {
      const queueData = await this.extractsService.list_queues().toPromise();
      this.queueList = ['all', ...(queueData || [])];
      this.filteredQueueList = [...this.queueList];
    } catch (error) {
      console.error('Erreur lors du chargement des queues', error);
      this.queueList = ['all'];
      this.filteredQueueList = ['all'];
    } finally {
      this.loadingQueues = false;
    }
  }

  filterDoList() {
    if (!this.doList || this.doList.length === 0) {
      this.filteredDoList = ['all'];
      return;
    }
    const searchText = (this.doSearchText || '').toString().toLowerCase().trim();
    this.filteredDoList = this.doList.filter(doItem =>
      doItem === 'all' || doItem.toString().toLowerCase().includes(searchText)
    );
  }

  cleanQueueName(queue: string): string {
    return queue.replace('_AE_QUEUE', '').trim();
  }

  filterAgentList() {
    if (!this.agentList || this.agentList.length === 0) {
      this.filteredAgentList = ['all'];
      return;
    }
    const searchText = (this.agentSearchText || '').toString().toLowerCase().trim();
    this.filteredAgentList = this.agentList.filter(agent =>
      agent === 'all' || agent.toString().toLowerCase().includes(searchText)
    );
  }

  filterQueueList() {
    if (!this.queueList || this.queueList.length === 0) {
      this.filteredQueueList = ['all'];
      return;
    }
    const searchText = (this.queueSearchText || '').toString().toLowerCase().trim();
    this.filteredQueueList = this.queueList.filter(queueItem =>
      queueItem === 'all' || queueItem.toString().toLowerCase().includes(searchText)
    );
  }

  async handleRapportClick(rapport: any) {
    this.selectedRapport = rapport.originalName;
    this.showFilters = true;
    this.rapportItems.forEach(item => item.selected = item.originalName === rapport.originalName);

    // Reset all filters and dates
    this.resetFilters();
    this.loading = true;

    try {
      if (this.INTERACTION_DOSSIER_REPORTS.includes(rapport.originalName)) {
        await this.loadDoList();
        this.agentList = ['all'];
        this.filteredAgentList = ['all'];
        this.queueList = ['all'];
        this.filteredQueueList = ['all'];
      } else if (this.AGENT_REPORTS.includes(rapport.originalName)) {
        await Promise.all([this.loadAgents(), this.loadQueueList()]);
        this.doList = ['all'];
        this.filteredDoList = ['all'];
      } else {
        await this.loadQueueList();
        this.doList = ['all'];
        this.filteredDoList = ['all'];
        this.agentList = ['all'];
        this.filteredAgentList = ['all'];
      }
    } catch (error) {
      console.error('Error loading filters:', error);
    } finally {
      this.loading = false;
    }
  }



  resetFilters() {
    this.selectedDo = 'all';
    this.selectedAgent = 'all';
    this.selectedQueue = 'all';
    this.startDate = undefined;
    this.endDate = undefined;
    this.doSearchText = '';
    this.agentSearchText = '';
    this.queueSearchText = '';
  }

  cleanReportName(fullName: string): string {
    return fullName
      .replace(/^ISUPPLEANCE_EXTRACTS_/, '')
      .replace(/_/g, ' ')
      .replace(/ PROD/g, '')
      .replace(/  +/g, ' ')
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  generateRapportItems(data: any): any[] {
    if (!data.production || data.production.length === 0) return [];

    const iconColors = [
      {icon: 'pi pi-file', color: '#3B82F6'},
      {icon: 'pi pi-table', color: '#10B981'},
      {icon: 'pi pi-file-excel', color: '#F59E0B'},
      {icon: 'pi pi-file-excel', color: '#10B981'}
    ];

    return data.production.map((name: string, index: number) => ({
      name: this.cleanReportName(name),
      originalName: name,
      icon: iconColors[index % iconColors.length].icon,
      color: iconColors[index % iconColors.length].color,
      selected: false
    }));
  }

  canExport(): boolean {
    if (!this.selectedRapport) return false;
    if (!this.startDate || !this.endDate || this.startDate > this.endDate) {
      return false;
    }

    if (this.INTERACTION_DOSSIER_REPORTS.includes(this.selectedRapport)) {
      return this.selectedDo !== undefined;
    } else if (this.AGENT_REPORTS.includes(this.selectedRapport)) {
      return this.selectedAgent !== undefined && this.selectedQueue !== undefined;
    } else {
      return this.selectedQueue !== undefined;
    }
  }

  startExport() {
    if (!this.canExport() || this.exporting) return;

    this.exporting = true;
    this.progressValue = 0;

    this.progressInterval = setInterval(() => {
      this.progressValue += Math.round(this.progressValue + Math.random() * 10);
      if (this.progressValue >= 100) {
        this.progressValue = 100;
        clearInterval(this.progressInterval);
        this.finalizeExport();
      }
    }, 300);
  }

  private getErrorMessage(error: any): string {
    if (error.status === 0) {
      return 'Erreur de connexion au serveur. Veuillez vérifier votre connexion réseau.';
    } else if (error.status === 404) {
      return 'La ressource demandée est introuvable.';
    } else if (error.status === 500) {
      return 'Erreur interne du serveur. Veuillez réessayer plus tard.';
    } else {
      return 'Une erreur est survenue lors du téléchargement. Veuillez réessayer.';
    }
  }

  private generateExportFileName(): string {
    const reportName = this.selectedRapport?.replace('ISUPPLEANCE_EXTRACTS_', '') || 'export';
    const dateStr = this.datePipe.transform(new Date(), 'yyyyMMdd_HHmm');
    return `${reportName}_${dateStr}.csv`;
  }

  finalizeExport() {
    if (!this.canExport()) return;

    const exportData = {
      rapport: this.selectedRapport,
      startDate: this.datePipe.transform(this.startDate, 'dd/MM/yyyy'),
      endDate: this.datePipe.transform(this.endDate, 'dd/MM/yyyy'),
      do: this.selectedDo !== 'all' ? this.selectedDo : undefined,
      agent: this.selectedAgent !== 'all' ? this.selectedAgent : undefined,
      queue: this.selectedQueue !== 'all' ? this.selectedQueue : undefined
    };

    const filters: string[] = [];
    if (exportData.agent) filters.push(exportData.agent);
    if (exportData.queue) filters.push(exportData.queue);
    if (exportData.do) filters.push(exportData.do);

    const filterValue = filters.length > 0 ? filters.join('_') : 'all';

    this.extractsService.exportReport(
      this.selectedRapport!,
      filterValue,
      exportData.startDate!,
      exportData.endDate!,
      true
    ).subscribe({
      next: (response) => {
        const filename = this.generateExportFileName().replace('.xlsx', '.csv');
        this.extractsService.downloadFile(response, filename);
        this.resetAfterAction();

        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'Export terminé avec succès!',
          life: 3000
        });
      },
      error: (error) => {
        console.error('Erreur lors de l\'export:', error);
        this.resetAfterAction();

        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.getErrorMessage(error),
          life: 5000
        });
      }
    });
  }

   showPreview() {
    if (!this.canExport()) return;

    this.loadingPreview = true;
    this.previewVisible = true;
    this.previewData = [];

    const startDate = this.datePipe.transform(this.startDate, 'dd/MM/yyyy');
    const endDate = this.datePipe.transform(this.endDate, 'dd/MM/yyyy');

    const filters: string[] = [];
    if (this.selectedAgent !== 'all') filters.push(this.selectedAgent);
    if (this.selectedQueue !== 'all') filters.push(this.selectedQueue);
    if (this.selectedDo !== 'all') filters.push(this.selectedDo);

    const filterValue = filters.length > 0 ? filters.join('_') : 'all';

    this.extractsService.previewReport(
      this.selectedRapport!,
      filterValue,
      startDate!,
      endDate!
    ).subscribe({
      next: (response) => {
        this.previewData = response.preview || [];
        this.previewColumns = response.columns ?
          response.columns.map((col: string) => ({field: col, header: col})) :
          [];

        if (this.previewData.length === 0) {
          this.messageService.add({
            severity: 'info',
            summary: 'Information',
            detail: 'Aucune donnée disponible pour les filtres sélectionnés',
            life: 5000
          });
          this.resetAfterAction();

        }

        this.loadingPreview = false;
      },
      error: (error) => {
        console.error('Erreur lors de la prévisualisation:', error);
        this.loadingPreview = false;
        this.previewData = [];

        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors du chargement de l\'aperçu',
          life: 5000
        });
      }
    });
  }

  resetAfterAction() {
    this.exporting = false;
    this.progressValue = 0;
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }

    // Reset filters but keep the selected report
    this.selectedDo = 'all';
    this.selectedAgent = 'all';
    this.selectedQueue = 'all';
    this.startDate = undefined;
    this.endDate = undefined;

    // Reset filtered lists
    this.filteredDoList = this.doList.length > 1 ? [...this.doList] : ['all'];
    this.filteredAgentList = this.agentList.length > 1 ? [...this.agentList] : ['all'];
    this.filteredQueueList = this.queueList.length > 1 ? [...this.queueList] : ['all'];

    // Reset search texts
    this.doSearchText = '';
    this.agentSearchText = '';
    this.queueSearchText = '';
  }

  onDoChange() {
    this.startDate = undefined;
    this.endDate = undefined;
  }

  onAgentChange() {
    this.startDate = undefined;
    this.endDate = undefined;
  }

  onQueueChange() {
    this.startDate = undefined;
    this.endDate = undefined;
  }
}
